function isSuper(){
    try {    
      return JSON.parse(window.localStorage.getItem('user_data'))?.super === 1;
    } catch (error) {
        return false;   
    }
  }

  export default isSuper